import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/Button';
import styles from './NotFoundPage.module.css';

export function NotFoundPage() {
  return (
    <div className={styles.page}>
      <div className={styles.code}>404</div>
      <h1 className={styles.title}>Страница не найдена</h1>
      <p className={styles.subtitle}>
        К сожалению, запрашиваемая страница не существует или была перемещена.
      </p>
      <Link to="/">
        <Button size="lg">На главную</Button>
      </Link>
    </div>
  );
}
